export const blockIconsDeviceDevices = (
	<span className='material-symbols-outlined'>devices</span>
);
